import { apiEndpoint } from '@/environment'
import type { AppType } from '@worker/api'
import { hc } from 'hono/client'

export const apiClient = hc<AppType>(apiEndpoint)
